import React from 'react'
import ReactDOM from 'react-dom/client'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import App from './App'
import { ToastProvider, ConfirmProvider } from './components/ui'
import './styles/index.css'

// Optional Sentry initialization — lazy loaded so the SDK never lands in
// the bundle for environments that don't opt in via VITE_SENTRY_DSN.
const SENTRY_DSN = import.meta.env.VITE_SENTRY_DSN
if (SENTRY_DSN) {
  import('@sentry/browser')
    .then((Sentry) => {
      Sentry.init({
        dsn: SENTRY_DSN,
        environment: import.meta.env.MODE,
        tracesSampleRate: 0,
        // Forward correlation header from the API on outgoing fetches.
        beforeSend(event) {
          return event
        },
      })
    })
    .catch((err) => {
      // Sentry is optional; never block app boot if the dynamic import fails.
      console.warn('Sentry browser SDK failed to load:', err?.message || err)
    })
}

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 5 * 60 * 1000,
      retry: 1,
    },
  },
})

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <ToastProvider>
        <ConfirmProvider>
          <App />
        </ConfirmProvider>
      </ToastProvider>
    </QueryClientProvider>
  </React.StrictMode>,
)
